<!--
 * @Author: pyx 3245266940@qq.com
 * @Date: 2023-04-06 15:27:13
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-21 10:27:43
 * @FilePath: \org-wx-front\src\views\receiveCoupon.vue
 * @Description: 领取现金券页面
-->
<template>
    <div>
        <!-- 错误提示语 -->
        <div class="alsrtInfo" v-if="displayStsates">
            <div class="profPrompt_test center">
                <span>{{ aletMsg }}</span>
            </div>
        </div>
        <!-- 填写表单页面 -->
        <div v-if="!isSuccess">
            <img src="../assets/static/receiveCouponImg.png" alt="" class="receiveCouponImg">
            <div class="rowAc noXkUserBox" v-if="notXkUser">
                <div class="line"></div>
                <div class="noXkUserText">您还不是旭课的用户，补充资料后立即领取优惠券</div>
            </div>
            <div class="formBox">
                <div class="rowAc attribute">
                    <div class="mustIcon">*</div>
                    <div>机构名称</div>
                </div>
                <input type="text" class="inputBox" v-model="institutionName" maxlength="30" ref="institutionName" placeholder="请输入机构名称">
                <div class="rowAc attribute">
                    <div class="mustIcon">*</div>
                    <div>老师姓名</div>
                </div>
                <input type="text" class="inputBox" v-model="teacherName" maxlength="30" ref="teacherName"  placeholder="请输入老师姓名">
                <div class="rowAc attribute">
                    <div class="mustIcon">*</div>
                    <div>联系电话</div>
                </div>
                <input type="tel" class="inputBox" :class="[customerInfo || notXkUser ? 'inputDisable' : '']" :disabled="customerInfo || notXkUser" v-model="phone" ref="phone" placeholder="请输入联系电话" maxlength="11">
                <div class="verificationCodeBox rowAc" v-if="!(customerInfo)">
                    <input type="tel" class="verificationCodeInput" v-model="verificationCode" ref="verificationCode" placeholder="请输入验证码" maxlength="6">
                    <div class="line"></div>
                    <div 
                        class="verificationCodeText"
                        :class="[isCounDown?'grayColor': 'blueColor']" 
                        @click="clickGetCode"
                    >
                        {{isCounDown ? '重新发送('+countDown+')' : '获取验证码'}}
                    </div>
                </div>
                <div class="receiveBtn" @click="clickReceiveCoupon">领取现金券</div>
                <div class="tips">*旭课平台将严格保密客户的各项信息</div>
            </div>
            
        </div>
        <!-- 领取成功页面 -->
        <div v-else class="colAc successBox">
            <img src="../assets/static/success.svg" class="successImg" alt="">
            <div class="successText">领取成功</div>
            <div class="successTips">优惠券已发放到您的旭课账户</div>
            <div class="successTips">同时我们将有旭课系统指导人员联系您</div>
            <div class="ensureBtn" @click="clickEnsure">确定</div>
        </div>
    </div>
</template>
<script>
    import {postVerifyCodeSendAPI,postAccountRegisterAPI,postLoginAPI,postCouponReceiveCheckAPI,postCouponReceiveAPI} from '../utils/api/api'
    export default{
        data() {
            return {
                notXkUser: false, // 是否为旭课用户
                isSuccess: false, // 是否领取成功
                institutionName: '', // 机构名称
                teacherName: '', // 老师名称
                phone: '', // 联系电话
                verificationCode: '', // 验证码
                displayStsates: false, // 提示语弹框是否展示
                aletMsg: '', // 提示语
                countDown: 60, // 倒计时
                countDownTimer: '', // 倒计时器
                isCounDown: false, // 是否在倒计时
                openid: '', // openid
                customerInfo: false, // 登录的客户信息

            }
        },
        created() {
            this.openid = this.$common.getCache('openid');
            if(this.$common.getCache('loginPhone')) {
                this.phone = this.$common.getCache('loginPhone')
                this.$common.removeCache('loginPhone')
                this.notXkUser = true
            }else {
                this.postCouponReceiveCheck()
            }
            
        },
        methods: {
            // 点击领取现金券
            clickReceiveCoupon() {
                if(!this.checkForm('institutionName','请输入机构名称')) {
                    return
                }
                if(!this.checkForm('teacherName','请输入老师姓名')) {
                    return
                }
                if(!this.checkForm('phone','请输入联系电话')) {
                    return
                }
                if(!this.customerInfo && !this.$common.checkPhone(this.phone)) {
                    this.aletMsg = '请输入正确的手机号'
                    this.displayStsates = true
                    setTimeout(() => {
                        this.displayStsates = false
                    },2000)
                    return
                }
                if(!this.customerInfo && !this.checkForm('verificationCode','请输入验证码')) {
                    return
                }
                if(!this.customerInfo && this.verificationCode.trim().length < 6) {
                    this.aletMsg = '验证码最少为6位'
                    this.displayStsates = true
                    setTimeout(() => {
                        this.displayStsates = false
                    },2000)
                    return
                }
                // this.isSuccess = true
                clearInterval(this.countDownTimer)
                this.countDownTimer = ''
                this.isCounDown = false
                if(this.customerInfo) { // 之前已经登录过
                    this.postCouponReceive()
                }else {
                    this.postAccountRegister()
                }
                
            },
            // 点击获取倒计时
            clickGetCode() {
                if(!this.checkForm('phone','请输入联系电话')) {
                    return
                }
                if(!this.$common.checkPhone(this.phone)) {
                    this.aletMsg = '请输入正确的手机号'
                    this.displayStsates = true
                    setTimeout(() => {
                        this.displayStsates = false
                    },2000)
                    return
                }
                if(this.isCounDown) {
                    return
                }
                this.isCounDown = true
                this.postCheck()
                
            },
            // 检查是否填写值
            checkForm(attr, mes) {
                if(this[attr] === '') {
                    this.$refs[attr].focus()
                    this.aletMsg = mes
                    this.displayStsates = true
                    setTimeout(() => {
                        this.displayStsates = false
                    },2000)
                    return false
                }else {
                    return true
                }
            },
            // 预检查
            postCheck() {
                postVerifyCodeSendAPI({
                    phone: this.phone
                }).then(res => {
                    console.log('预检查接口：', res)
                    if(res.resultCode == 200) {
                        this.countDown = 60
                        this.countDownTimer = setInterval(() => {
                            this.countDown = this.countDown - 1
                            if(this.countDown == 0) {
                                clearInterval(this.countDownTimer)
                                this.countDownTimer = ''
                                this.isCounDown = false
                            }
                        },1000) 
                    }else {
                        this.aletMsg = res.resultStr
                        this.displayStsates = true
                        setTimeout(() => {
                            this.displayStsates = false
                        },2000)
                        this.countDownTimer = ''
                        this.isCounDown = false
                        this.countDown = 60
                    }
                    
                })
            },
            // 注册、领取
            postAccountRegister() {
                postAccountRegisterAPI({
                    productId: 1,
                    clientId: '1004',
                    phone: this.phone,
                    thirdUniqueId: this.openid,
                    name: this.teacherName,
                    institutionName: this.institutionName,
                    verifyCode: this.verificationCode
                }).then(res => {
                    console.log('用户第三方账号注册/领取产品购买优惠券:', res)
                    if(res.resultCode == 200) {
                        this.postLogin()
                    }else {
                        this.aletMsg = res.resultStr
                        this.displayStsates = true
                        setTimeout(() => {
                            this.displayStsates = false
                        },2000)
                    }
                })
            },
            // 已经登录的用户领取优惠券
            postCouponReceive(){
                postCouponReceiveAPI({
                    institutionName: this.institutionName,
                    name: this.teacherName,
                    phone: this.phone,
                    configId: 1
                }).then(res => {
                    if(res.resultCode == 200) {
                        this.isSuccess = true
                    }else {
                        this.aletMsg = res.resultStr
                        this.displayStsates = true
                        setTimeout(() => {
                            this.displayStsates = false
                        },2000)
                    }
                })
            },
            // 登录
            postLogin() {
                postLoginAPI({
                    loginMode: 2,
                    productId: 1,
                    clientId: '1004',
                    thirdUniqueId: this.openid,
                }).then(res => {
                    if(res.resultCode == 200) {
                        this.$common.setCache('tokenCreateTime', new Date().getTime())
                        this.$common.setCache('token',res.data.token)
                        this.$common.setCache('customerInfo',JSON.stringify(res.data))
                        this.isSuccess = true
                    }
                })
            },
            // 检查优惠券是否领取
            postCouponReceiveCheck() {
                if(this.$common.getCache('token') && this.$common.getCache('customerInfo')) {
                    this.customerInfo = JSON.parse(this.$common.getCache('customerInfo'))
                    this.phone = this.customerInfo.phone
                    postCouponReceiveCheckAPI({
                        phone: this.customerInfo.phone,
                        configId: 1
                    }).then(res => {
                        if(res.resultCode == 200 && res.data.isReceive) {
                            this.isSuccess = true
                        }
                    })
                }
                
            },
            clickEnsure() {
                this.$router.replace('/mine')
            }
        }
    }
</script>
<style scoped lang="scss">
.receiveCouponImg {
    width: 100%;
}
.formBox {
    padding: .12rem .16rem;
}
.attribute {
    font-size: 0.16rem;
    line-height: 0.22rem;
    color: #3C4353;
    margin-top: .2rem;
    .mustIcon {
      color: #FA3F3F;
      margin-right: 0.04rem;  
    }
}
.noXkUserBox {
    margin-top: .32rem;
    margin-left: .12rem;
    .line {
        width: .03rem;
        height: .14rem;
        background-color: #FA5D00;
        border-radius: .02rem;
        margin-right: .06rem;
    }
    .noXkUserText {
        color: #3C4353;
        font-size: .15rem;
        line-height: .22rem;
        font-weight: 500;
    }
}
.verificationCodeBox {
    height: .4rem;
    box-sizing: border-box;
    border-radius: .04rem;
    border: 1px solid #DCDEE0;
    font-size: .16rem;
    line-height: .22rem;
    width: 100%;
    padding: 0 .12rem;
    margin-top: .2rem;
    .verificationCodeInput {
        flex: 1;
        color: #3C4353;
        font-size: .16rem;
        line-height: .22rem;
        height: .22rem;
    }
    .line {
        width: 0.5px;
        height: .14rem;
        background-color: #C8C9CC;
        // margin: 0 .16rem;
    }
    .verificationCodeText {
        // width: .86rem;
        padding-left: .16rem;
        text-align: right;
        font-size: .14rem;
    }
    .blueColor {
        color: #1A7AF8;
    }
    .grayColor {
        color: #C8C9CC;
    }
}
.inputBox {
    height: .4rem;
    box-sizing: border-box;
    border-radius: .04rem;
    border: 1px solid #DCDEE0;
    color: #3C4353;
    font-size: .16rem;
    line-height: .22rem;
    width: 100%;
    padding: 0 .12rem;
    margin-top: .12rem;
}
.inputDisable {
    background-color: #DCDEE0;
}
input::input-placeholder {
    color: #C8C9CC;
}
input::-webkit-input-placeholder {
    color: #C8C9CC;
}
input::-moz-input-placeholder {
    color: #C8C9CC;
}
input:-moz-input-placeholder {
    color: #C8C9CC;
}
input::-ms-input-placeholder {
    color: #C8C9CC;
}
.receiveBtn {
    height: .44rem;
    line-height: .44rem;
    text-align: center;
    color: #ffffff;
    font-size: .16rem;
    border-radius: .06rem;
    background-color: #FA5D00;
    margin-top: .6rem;
}
.tips {
    font-size: .12rem;
    line-height: .18rem;
    color: #9EA5BB;
    margin-top: .1rem;
}
.successBox {
    .successImg {
        width: .8rem;
        height: .8rem;
        margin-top: .48rem;
        margin-bottom: .08rem;
    }
    .successText {
        font-size: .18rem;
        line-height: .26rem;
        font-weight: 500;
        color: #191C27;
        margin-bottom: .08rem;
    }
    .successTips {
        color: #9EA5BB;
        font-size: .14rem;
        line-height: .20rem;
    }
    .ensureBtn {
        margin-top: .44rem;
        height: .44rem;
        font-size: .16rem;
        line-height: .44rem;
        color: #ffffff;
        background-color: #FA5D00;
        border-radius: .06rem;
        text-align: center;
        width: calc(100% - .24rem);
    }
}
.alsrtInfo {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 80%;
  left: 4%;
  z-index: 1000;
}
.profPrompt_test {
  display: inline-block;
  height: 44px;
  width: 345px;
  font-size: 12px;
  background: #222222;
  border-radius: 11px;
  line-height: 44px;
  padding: 0px 25px;
  box-sizing: border-box;
  margin: auto;
  color: #ffffff;
}

</style>